<!-- 安全管理 -->
<template>
  <div class="smhome flex_row apphome">
    <!-- <leftcolumn class="app5760 flex_column" /> -->
    <div class="left flex_column">
      <div class="top">
        <div class="mybox">
          <div class="title">安防视频
            <div class="tab_title">
              <li v-for="(item,index) in jiankong" :key="index" :class="jiankongid==index?'active':''" @click="jiankongid = index;getcameraView(jiankong[index].child)">{{item.name}}</li>
            </div>
          </div>
          <div class="box ailist">

            <div v-for="(item,i) in 4" :key="i">

              <div class="img"  @click.stop.capture ="getBigCameraView(jiankong[jiankongid].child[i])">
                <template v-if="jiankong[jiankongid].child[i]!=null">
                  <div class="title">
                    <span>{{jiankong[jiankongid].child[i].time}}</span>
                    <span>{{jiankong[jiankongid].child[i].name}}</span>
                  </div>
                  <!-- <video autoplay loop height='100%' width='100%' :src="jiankong[jiankongid].child[index].videoUrl" controls>您的浏览器不支持 video 标签。</video> -->
             
                  <xgPlayer :ref="'xgPlayerVideo' + i"  />

          
                  


                </template>

                <img v-else class="novideo" src="@/assets/images/novideo.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom flex_column">
        <div class="mybox">
          <div class="title">风险指数</div>
          <div class="box">
            <RiskIndex />
          </div>
        </div>

        <!-- 屏蔽日期 2024年9月22日 -->

        <!-- <div class="mybox">
          <div class="title">消防设备 <span @click="$refs.xfboxdialog.openDialog()" class="more el-icon-more"></span></div>
          <div class="box">
            <div id="sm_pie" class="echarts"></div>
          </div>
        </div> -->

      </div>
    </div>
    <div class="center flex_column">
      <div class="top">
        <div class="mybox">
          <div class="title">实时状态</div>
          <div class="box realtime">

            <el-button v-if="bigCamera" @click="getBigCameraView({videoUrl:configurationMap},false);bigCamera= ''" type="primary" size="mini" icon="el-icon-back"  class="goBack" >返回</el-button>

            <xgPlayer  ref="configurationMap"  />

            <!-- <iframe v-if="configurationMap" width="100%" height="100%" :src="configurationMap" frameborder="0"></iframe> -->

            <!-- <RealTimeStatus></RealTimeStatus> -->
          </div>
        </div>
      </div>

      <el-dialog v-dialogDrag :visible.sync="TopDialog" width="30%" title="安全风险详情">
        <div>

          <el-form label-width="5rem">
            <el-row :gutter="0" style="border-bottom: #555e86 dashed 1px;">
              <el-col :span="12">
                <el-form-item label="区域名称 :" style="margin:0">
                  <span style="color:#fff; font-size:.8rem">{{TopDialogInfo.name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="风险指数 :" style="margin:0">
                  <span style="color:#fff; font-size:.8rem" v-if="TopDialogInfo.value==3">高风险</span>
                  <span style="color:#fff; font-size:.8rem" v-else-if="TopDialogInfo.value==2">中风险</span>
                  <span style="color:#fff; font-size:.8rem" v-else>低风险</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="0" style="min-height:6rem">
              <el-col :span="24">
                <el-form-item label="风险原因 :">
                  <span style="color:#fff; font-size:.8rem">{{TopDialogInfo.safeCase}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-dialog>
      <div class="bottom flex_column">
        <div class="myboxs center_top">
          <div class="mybox1" v-for="(item,index) in centerTopData" :key="index">
            <div class="title1">{{item.name}}</div>
            <div :id="'lipie'+item.id" class="echarts"></div>
            <div class="table">

              <li v-for="(list,i) in item.textlist" @click="TopDialogInfo=item.textlist[i];TopDialog=true" :key="i">
                <span>{{list.name}}</span>
                <span v-if="list.value==3" class="f_red">高风险</span>
                <span v-else-if="list.value==2" class="f_orange">中风险</span>
                <span v-else>低风险</span>
              </li>

            </div>
          </div>
        </div>


        <!-- 屏蔽日期 2024年9月22日 -->

        <!-- <div class="mybox">
          <div class="title">风险提示</div>
          <vue-seamless-scroll class="box " :data="fxlist" :class-option="{limitMoveNum: 6,direction: 1,step: 0.4,}">
            <ul class="fxlist">
              <p v-if="!fxlist.length" style="text-align: center;margin-top: 1rem;">暂无数据</p>
              <li :riskdata-index='index' v-for="(item, index) in fxlist" :key="index">
                <i class="el-icon el-icon-warning" :style="item.status==1?'color:#f95458':''"></i>
                <span>{{item.alarmAddress}} / {{item.subject}}</span>
                <span>{{item.alarmCase}}</span>
                <span>{{item.status===1?'报警中':'已恢复'}}</span>
                <span>{{item.handleStatus===1?'已处理':'未处理'}}</span>
                <span>{{item.advise}}</span>
                <span>{{item.alarmTime}}</span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div> -->


      </div>
    </div>
    <div class="right flex_column">
      <div class="top">
        <div class="mybox">
          <div class="title">AI安全
            <div class="tab_title">
              <li v-for="(item,index) in AIlist" :key="index" :class="AIsafety==index?'active':''" @click="AIsafety = index;getcameraView(AIlist[index].child,'AIxgPlayerVideo')">{{item.name}}</li>
            </div>
          </div>
          <div class="box ailist">
            <div v-for="(item,i) in 4" :key="i">
              <div class="img" @click.stop.capture ="getBigCameraView(AIlist[AIsafety].child[i])">
                <template v-if="AIlist[AIsafety].child[i]!=null">
                  <div class="title">
                    <span>{{AIlist[AIsafety].child[i].time}}</span>
                    <span>{{AIlist[AIsafety].child[i].name}}</span>
                  </div>
                  <!-- <video autoplay loop height='100%' width='100%' :src="AIlist[AIsafety].child[i].videoUrl" controls>您的浏览器不支持 video 标签。</video> -->

                  <xgPlayer :ref="'AIxgPlayerVideo' + i"  />



                </template>
                <img v-else class="novideo" src="../../assets/images/novideo.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom flex_column">
        <div class="mybox">
          <div class="title">行为监控</div>

          <vue-seamless-scroll class="box " :data="xwlist" :class-option="{limitMoveNum: 6,direction: 1,step: 0.4,}">
            <ul class="xwlist">
              <p v-if="!xwlist.length" style="text-align: center;margin-top: 1rem;">暂无数据</p>
              <li v-for="(item, index) in xwlist" :key="index">
                <span>{{item.eventArea}}</span>
                <span>{{item.eventBody}}</span>
                <span>{{item.eventCase}}</span>
                <span>{{item.eventTime}}</span>
              </li>
            </ul>
          </vue-seamless-scroll>

        </div>
      </div>
    </div>
    <!-- <rightcolumn class="app5760 flex_column" /> -->

    <el-dialog v-dialogDrag :visible.sync="FXdialog" width="75rem" title="风险提示详情">
      <div class="FXdialog">
        <div class="left">
          <el-row>
            <el-col :span="24">
              <div class="title">报警信息</div>
              <div class="message">
                <div class="text"><b>{{fxlistValue.subject}}</b><span>关联区域/设备 {{fxlistValue.alarmAddress}}</span></div>
                <div class="error"><i class="el-icon-warning-outline"></i>{{fxlistValue.alarmCase}}</div>
                <div class="time"><i class="el-icon-time"></i>{{fxlistValue.alarmTime}}</div>

                <div v-if="fxlistValue.status ===2" class="state">已恢复</div>
                <div v-else class="state ing">报警中</div>
              </div>
              <div class="myform">
                <div class="col2"><label>报警类型：</label><span>{{fxlistValue.alarmType==1?'运行报警':'管理报警'}}</span></div>
                <div class="col2"><label>报警等级：</label><span>{{fxlistValue.alarmLevel}}级报警</span></div>
                <div class="col2"><label>报警时间：</label><span>{{fxlistValue.alarmTime}}</span></div>
                <div class="col2"><label>恢复时间：</label><span>{{fxlistValue.recoverTime}}</span></div>
                <div class="col2"><label>通知对象：</label><span>{{fxlistValue.notifyBody}}</span></div>
                <div class="col2"><label>通知方式：</label><span>{{fxlistValue.notifyType}}</span></div>
                <div class="col2"><label>处理状态：</label><span>{{fxlistValue.alarmType==1?'已处理':'未处理'}}</span></div>
                <div class="col2"><label>处理方式：</label><span>{{fxlistValue.handleType}}</span></div>
                <div class="col1"><label>报警信息：</label><span>{{fxlistValue.description}}</span></div>
              </div>
              <div class="map">
                <Amap @amapDone="amapDone" style="width: 100%;height: 100%;min-height: 10rem;" ref="Amap"></Amap>

              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="title">现场视频</div>
              <div class="video">
                <!-- <div class="title1"><span>2020-05-09 12:14:25</span><span>办公室2</span></div> -->
                <video height='100%' width='100%' v-if='fxlistValue.liveVideo' :src="fxlistValue.liveVideo" controls>您的浏览器不支持 video 标签。</video>
                <img v-else src="@/assets/images/novideo.png" class="novideo">
              </div>
            </el-col>
            <el-col :span="12">
              <div class="title">回放视频</div>
              <div class="video">
                <video height='100%' width='100%' v-if='fxlistValue.playbackVideo' :src="fxlistValue.playbackVideo" controls>您的浏览器不支持 video 标签。</video>
                <img v-else src="@/assets/images/novideo.png" class="novideo">
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="right">
          <el-row>
            <el-col :span="24">
              <div class="title">异常预案</div>
              <el-row>
                <el-col :span="12">
                  <div class="select">
                    <el-select v-model="planId" @change="planChange" placeholder="请选择">
                      <el-option v-for="item in planList" :key="item.value" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="col2" style="line-height:1.6rem; font-size:.7rem; color:#24ffb1"><label>预案等级：</label><span>{{planValue.level?planValue.level:'--'}}级</span></div>

                </el-col>

              </el-row>

              <div class="myform">
                <div class="col2"><label>总指挥：</label><span>{{planValue.chief?planValue.chief:'--'}}</span></div>
                <div class="col2"><label>救援方式：</label><span>{{planValue.type ==1 ?'内部救援':'消防救援'}}</span></div>
                <div class="col2"><label>疏散时长：</label><span>{{planValue.times?planValue.times:'--'}}分钟</span></div>
                <div class="col2"><label>灭火负责人：</label><span>{{planValue.fightingLeader?planValue.fightingLeader:'--'}}</span></div>
                <div class="col2"><label>疏散范围：</label><span>{{planValue.evacuate?planValue.evacuate:'--'}}米</span></div>
                <div class="col2"><label>灭火队员：</label><span>{{planValue.fightingTeam?planValue.fightingTeam:'--'}}</span></div>
                <div class="col2"><label>疏散负责人：</label><span>{{planValue.evacuateLeader?planValue.evacuateLeader:'--'}}</span></div>
                <div class="col2"><label>后勤负责人：</label><span>{{planValue.evacuateTeam?planValue.evacuateTeam:'--'}}</span></div>
                <div class="col2"><label>疏散队员：</label><span>{{planValue.logisticsLeader?planValue.logisticsLeader:'--'}}</span></div>
                <div class="col2"><label>后勤队员：</label><span>{{planValue.logisticsTeam?planValue.logisticsTeam:'--'}}</span></div>
                <div class="col1"><label>预案内容：</label><span>{{planValue.content?planValue.content:'--'}}</span></div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="title">报警日志</div>
              <div class="box">
                <el-steps direction="vertical">
                  <el-step :title="fxlistValue.alarmTime" :description="fxlistValue.alarmAddress+fxlistValue.subject+'发出报警信息'"></el-step>
                  <el-step :title="new Date(new Date(fxlistValue.alarmTime).getTime() + Math.floor(Math.random()*5000000)).Format('yyyy-MM-dd hh:mm:ss')" :description="fxlistValue.notifyBody+'确认了此报警信息'"></el-step>
                  <!-- <el-step title="2020-02-02 15:36:24" description="刘平宽将此报警信息修改为已派单状态"></el-step> -->
                  <el-step v-if="fxlistValue.recoverTime" :title="fxlistValue.recoverTime" :description="fxlistValue.alarmAddress+fxlistValue.subject+'发出恢复信息，此报警处理完毕'"></el-step>
                </el-steps>
              </div>
            </el-col>
          </el-row>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="FXdialog = false" type="primary">关闭</el-button>
        <!-- <el-button type="primary">解除报警</el-button>
        <el-button type="warning">一键派单</el-button>
        <el-button type="danger">启动预案</el-button> -->
      </span>
    </el-dialog>

    <!-- 消防设备弹窗 -->
    <xfboxdialog ref="xfboxdialog" />

  </div>
</template>

<script>
import xgPlayer from '@/components/xgPlayer/index.vue';

let echarts = require('echarts/lib/echarts')
// import RealTimeStatus from '../../components/RealTimeStatus' //实时状态
import RiskIndex from './RiskIndex' //风险指数
import api from '@/apis/SecurityManagement'
import vueSeamlessScroll from 'vue-seamless-scroll'
import Amap from '@/components/AMap'

import xfboxdialog from './xfboxdialog.vue'
import camera from '@/apis/safety/camera'

// import leftcolumn from '@/views/CompanyProfile/leftcolumn.vue'
// import rightcolumn from '@/views/SecurityManagement/rightcolumn.vue'

export default {
  components: {
    xgPlayer,

    Amap,
    vueSeamlessScroll,
    xfboxdialog,

    // RealTimeStatus,
    RiskIndex,
    // leftcolumn,
    // rightcolumn,
  },
  data() {
    return {
      FXdialog: false,
      TopDialog: false,
      TopDialogInfo: {},
      xfboxdialog: false,
      activeName1: 'lq',
      activeName2: 'first',
      fxlistValue: {
        advise: '', //建议
        alarmAddress: '', //区域
        alarmArea: '', //所在位置
        alarmCase: '', //异常类别
        alarmLevel: '3', //报警等级
        alarmTime: '', //报警时间
        description: '', //事件详情
        handleStatus: 2, //处理状态 1：已处理 2 未处理
        handleType: '', //处理方式
        liveVideo: '', //现场视频
        notifyBody: '', //通知对象
        notifyType: '', //通知方式
        playbackVideo: '', //回放视频
        recoverTime: '', //恢复时间
        status: 1, //1报警中 2已恢复
        subject: '', //事件主题
        alarmType: 1, //报警类型 1 运行报警 2 管理报警
        longitude: '', //经度
        latitude: '', //纬度
      },
      fxlist: [
        // {
        //   id: 0,
        //   name: '东区二车间',
        //   type: '电压不稳定',
        //   state: '报警中',
        //   fx: '中风险',
        //   text: '建议安装电压稳定设备',
        //   time: '2021-06-24 14:25:34',
        // },
        // {
        //   id: 1,
        //   name: '东区一车间破碎机',
        //   type: '电流超负荷',
        //   state: '已恢复',
        //   fx: '高风险',
        //   text: '建议检查超负荷原因并及时处理',
        //   time: '2021-06-24 14:25:34',
        // },
        // {
        //   id: 2,
        //   name: '东区二车间1号生产线',
        //   type: '电压不稳定',
        //   state: '报警中',
        //   fx: '中风险',
        //   text: '建议安装电压稳定设备',
        //   time: '2021-06-24 14:25:34',
        // },
        // {
        //   id: 3,
        //   name: '东区二车间破碎机',
        //   type: '电压不稳定',
        //   state: '报警中',
        //   fx: '中风险',
        //   text: '建议安装电压稳定设备',
        //   time: '2021-06-24 14:25:34',
        // },
        // {
        //   id: 4,
        //   name: '西区区二车间',
        //   type: '电流超负荷',
        //   state: '报警中',
        //   fx: '高风险',
        //   text: '建议检查超负荷原因并及时处理',
        //   time: '2021-06-24 14:25:34',
        // },
        // {
        //   id: 5,
        //   name: '东区二车间',
        //   type: '电压不稳定',
        //   state: '已恢复',
        //   fx: '中风险',
        //   text: '建议安装电压稳定设备',
        //   time: '2021-06-24 14:25:34',
        // },
      ],
      xwlist: [
        //   {id:0,eventArea:'东区二车间',eventBody:'邓维',eventCase:'未佩戴安全头盔',eventTime:'2021-06-24 14:25:34'},
        //   {id:1,eventArea:'东区一车间破碎机',eventBody:'邓维',eventCase:'未佩戴安全头盔',eventTime:'2021-06-24 14:25:34'},
        //   {id:2,eventArea:'东区二车间1号生产线',eventBody:'邓维',eventCase:'抽烟',eventTime:'2021-06-24 14:25:34'},
      ],
      jiankongid: 0,
      jiankong: [
        {
          id: 0,
          name: '办公室',
          child: [
            {
              id: 0,
              name: '办公室',
              time: '2021-04-04 15:00:47',
              path: '',
              src: require('../../assets/images/pic2.png'),
            },
            {
              id: 1,
              name: '办公室',
              time: '2021-04-04 15:00:47',
              path: '',
              src: require('../../assets/images/pic2.png'),
            },
          ],
        },
        {
          id: 0,
          name: '停车场',
          child: [
            {
              id: 0,
              name: '停车场',
              time: '2021-04-04 15:00:47',
              path: '',
              src: require('../../assets/images/pic2.png'),
            },
          ],
        },
        {
          id: 0,
          name: '停车场2',
          child: [],
        },
      ],
      AIsafety: 0,
      AIlist: [
        {
          id: 0,
          name: '办公室',
          child: [
            {
              id: 0,
              name: '请添加数据',
              time: '2021-04-04 15:00:47',
              path: '',
              videoUrl: require('../../assets/images/pic2.png'),
            },
            {
              id: 1,
              name: '请添加数据',
              time: '2021-04-04 15:00:47',
              path: '',
              videoUrl: require('../../assets/images/pic2.png'),
            },
            {
              id: 2,
              name: '请添加数据',
              time: '2021-04-04 15:00:47',
              path: '',
              videoUrl: require('../../assets/images/pic3.png'),
            },
          ],
        },
        {
          id: 0,
          name: '停车场',
          child: [
            {
              id: 0,
              name: '请添加数据',
              time: '2021-04-04 15:00:47',
              path: '',
              videoUrl: require('../../assets/images/pic2.png'),
            },
            {
              id: 1,
              name: '请添加数据',
              time: '2021-04-04 15:00:47',
              path: '',
              videoUrl: require('../../assets/images/pic2.png'),
            },
            {
              id: 2,
              name: '请添加数据',
              time: '2021-04-04 15:00:47',
              path: '',
              videoUrl: require('../../assets/images/pic3.png'),
            },
            {
              id: 3,
              name: '请添加数据',
              time: '2021-04-04 15:00:47',
              path: '',
              videoUrl: require('../../assets/images/pic3.png'),
            },
            {
              id: 4,
              name: '请添加数据',
              time: '2021-04-04 15:00:47',
              path: '',
              videoUrl: require('../../assets/images/pic3.png'),
            },
          ],
        },
      ],
      centerTopData: [
        {
          id: 0,
          name: '用能安全重点区域',
          pie: 0,
          textlist: [
            // { name: '总配电室', value: '高风险' },
            // { name: '1号配电室', value: '低风险' },
            // { name: '东区一车间空压机', value: '中风险' },
            // { name: '西区二车间高压破碎机', value: '低风险' },
            // { name: '碎机', value: '低风险' },
          ],
        },
        {
          id: 1,
          name: '人员安全区域',
          pie: 0,
          textlist: [
            // { name: '总配电室', value: '低风险' },
            // { name: '1号配电室', value: '低风险' },
            // { name: '东区一车间空压机', value: '中风险' },
            // { name: '西区二车间高压破碎机', value: '低风险' },
            // { name: '碎机', value: '低风险' },
          ],
        },
        {
          id: 2,
          name: '设备安全区域',
          pie: 0,
          textlist: [
            // { name: '总配电室', value: '低风险' },
            // { name: '1号配电室', value: '低风险' },
            // { name: '东区一车间空压机', value: '低风险' },
            // { name: '西区二车间高压破碎机', value: '低风险' },
            // { name: '碎机', value: '低风险' },
          ],
        },
        {
          id: 3,
          name: '交通安全区域',
          pie: 0,
          textlist: [
            // { name: '总配电室', value: '高风险' },
            // { name: '1号配电室', value: '低风险' },
            // { name: '东区一车间空压机', value: '中风险' },
            // { name: '西区二车间高压破碎机', value: '低风险' },
            // { name: '碎机', value: '低风险' },
          ],
        },
        {
          id: 4,
          name: '防火安全区域',
          pie: 0,
          textlist: [
            // { name: '总配电室', value: '高风险' },
            // { name: '1号配电室', value: '中风险' },
            // { name: '东区一车间空压机', value: '高风险' },
            // { name: '西区二车间高压破碎机', value: '高风险' },
            // { name: '碎机', value: '低风险' },
          ],
        },
      ],
      equipment_state: [
        { value: 47, name: '正常' },
        { value: 25, name: '临期' },
        { value: 10, name: '过期' },
        { value: 5, name: '未及时保养' },
      ],
      equipment_type: [
        { value: 32, name: '喷淋装置' },
        { value: 15, name: '报警装置' },
        { value: 14, name: '感应装置' },
        { value: 12, name: '消防栓' },
        { value: 8, name: '灭火器' },
        { value: 8, name: '其他消防设施' },
      ],

      planList: [{ id: '1', name: '暂无数据' }],
      planId: '1',
      planValue: {
        chief: '总指挥',
        companyId: '1283697230910644226',
        content: '预案内容',
        createTime: '2021-06-24 08:42:58',
        evacuate: '疏散范围',
        evacuateLeader: '疏散负责人',
        evacuateTeam: '后勤负责人',
        fightingLeader: '灭火负责人',
        fightingTeam: '灭火队员',
        id: '1407861772892106754',
        level: 1,
        logisticsLeader: '疏散队员',
        logisticsTeam: '后勤队员',
        name: '预案1',
        times:0 ,
        type: 1,
        unit: '',
        updateTime: '2021-06-24 08:47:05',
      },
      mapload: false,

      configurationMap: '',
      bigCamera: '',
    }
  },
  computed: {
    protocol(){
      return window.location.protocol=='https:' ? 'hlss' : 'hls'
    }
  },  
  methods: {
    getBigCameraView(row,flag=true){
      
      console.log(row);
      if (row) {
        if (flag) {
          this.bigCamera = row.videoUrl
        }

        camera
          .getCameraPreviewURL({
            params: {
              cameraIndexCode: row.videoUrl,
              protocol:  this.protocol,
              transmode: 1, //0:UDP 1:TCP
              streamType: 0,//码流
            },
          })
          .then((response) => {
            if (response.code == 10000) {

              //获取播放器
              this.$nextTick(()=>{
                let element = this.$refs.configurationMap
                if (element) {
                  element.closePlayer()
                  element.createPlayer(response.data.data.url, false,  false, true)
                }
              })
            } else {
              this.$message.error(response.message)
            }
          })
      }
      

    },
    getcameraView(data,flag='xgPlayerVideo'){

      for (const key in data) {
        
        camera
        .getCameraPreviewURL({
          params: {
            cameraIndexCode: data[key].videoUrl,
            protocol:  this.protocol,
            transmode: 1, //0:UDP 1:TCP
            streamType: 0,//码流
          },
        })
        .then((response) => {
          if (response.code == 10000) {

            //获取播放器
            this.$nextTick(()=>{
              let element = this.$refs[flag+key][0]
              if (element) {
                element.closePlayer()
                element.createPlayer(response.data.data.url, false,  false, false)
              }
            })
          } else {
            this.$message.error(response.message)
          }
        })

      }





      


    },
  
    handleClick1(tab, event) {
      console.log(tab, event)
    },
    handleClick2(tab, event) {
      console.log(tab, event)
    },

    amapDone() {
      console.log('HOMEAmap加载完成')
      if (!this.mapload) {
        this.mapload = true
        this.maplpad()
      }
    },
    lipie(id, data, text, color) {
      let lipie = echarts.init(document.getElementById('lipie' + id))
      lipie.setOption({
        color: color,
        title: [
          {
            text: '风险指数',
            x: 'center',
            top: '54%',
            textStyle: {
              color: '#ccd0f2',
              fontSize: this.$echartsFontSize - 4,
              fontWeight: '100',
            },
          },
          {
            text: text,
            x: 'center',
            top: '30%',
            textStyle: {
              fontSize: this.$echartsFontSize + 8,
              color: color,
              fontWeight: '400',
            },
          },
        ],
        polar: {
          radius: ['58%', '70%'],
          center: ['50%', '50%'],
        },
        angleAxis: {
          max: 100,
          show: false,
        },
        radiusAxis: {
          type: 'category',
        },
        series: [
          {
            type: 'bar',
            roundCap: true,
            barWidth: 60,
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(255, 255, 255, .2)',
            },
            data: [data],
            coordinateSystem: 'polar',
          },
        ],
      })
    
   },
    sm_pie(state, type) {
      let sm_pie = echarts.init(document.getElementById('sm_pie'))
      sm_pie.setOption({
        color: [
          '#00ccff',
          '#24ffb1',
          '#fff45c',
          '#f4af1b',
          '#ae74f3',
          '#f95458',
          '#3570ff',
          '#1ad38b',
          '#ff7b53',
          '#eedeb2',
        ],
        legend: {
          orient: 'vertical',
          right: '5%',
          icon: 'circle',
          top: 'center',
          data: state,
          itemHeight: this.$echartsFontSize - 8,
          itemWidth: this.$echartsFontSize - 8,
          itemGap: this.$echartsFontSize - 8,
          textStyle: {
            fontSize: this.$echartsFontSize,
            lineHeight: this.$echartsFontSize + 4,
            color: '#ccd0f2',
          },
          formatter: function (param) {
            let res = state.filter((v) => v.name === param)
            let percent = res[0].value
            return ' ' + param + '\n ' + percent + '个'
          },
        },
        series: [
          {
            name: '设备状态',
            type: 'pie',
            radius: [0, '40%'],
            center: ['38%', '50%'],
            label: { show: false },
            hoverAnimation: false,
            itemStyle: { borderColor: '#0f26aa', borderWidth: 1 },
            data: state,
          },
          {
            name: '设备类型',
            type: 'pie',
            radius: ['49%', '60%'],
            center: ['38%', '50%'],
            label: {
              formatter: '{b}\n{c}个',
              lineHeight: this.$echartsFontSize + 4,
              fontSize: this.$echartsFontSize,
              color: '#ccd0f2',
            },
            itemStyle: { borderColor: '#0f26aa', borderWidth: 1 },
            avoidLabelOverlap: true,
            data: type,
          },
        ],
      })
    },

    FXdialogclick(index) {
      //风险
      this.fxlistValue = this.fxlist[index]
      this.FXdialog = true
      if (this.mapload) {
        this.maplpad()
      }
    },
    //地图标点
    maplpad() {
      this.$nextTick(() => {
        this.$refs.Amap.punctuation([
          this.fxlistValue.longitude,
          this.fxlistValue.latitude,
        ])
      })
    },

    planChange(id) {
      for (const iterator of this.planList) {
        if (iterator.id == id) {
          return (this.planValue = iterator)
        }
      }
    },
  },
  mounted() {
    //获取实时状态
    api.timestatus().then((res) => {
      if (res.code == 10000) {
        if (res.data.list.length) {
          this.configurationMap = res.data.list[0].confUrl
          // configurationMap
          this.getBigCameraView({
            videoUrl:this.configurationMap
          },false)






        }
      }
    })

    //消防设备
    api
      .firecontrol({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {

 
          let data = res.data
          this.sm_pie(
            [
              { value: data.normal, name: '正常' },
              { value: data.lq, name: '临期' },
              { value: data.overTime, name: '过期' },
              { value: data.overOps, name: '未及时保养' },
            ],
            [
              { value: data['喷淋装置'], name: '喷淋装置' },
              { value: data['报警装置'], name: '报警装置' },
              { value: data['感应装置'], name: '感应装置' },
              { value: data['消防栓'], name: '消防栓' },
              { value: data['灭火器'], name: '灭火器' },
              { value: data['其他消防设施'], name: '其他消防设施' },
            ]
          )
      
          //   this.sm_pie(this.equipment_state, this.equipment_type)
     
          
        } else {
          this.$message.error(res.message)
        }
      })

    //行为监控
    api
      .behavior({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.xwlist = res.data.list
          }
        } else {
          this.$message.error(res.message)
        }
      })

    //AI安全
    api
      .ailist({
        params: {
          limit: 188,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.length) {
 
            for (const iterator of res.data) {
              if (iterator.child == null) {
                iterator.child = []
              }
            }
            this.AIlist = res.data

            if (this.AIlist.length) {
              this.getcameraView(this.AIlist[0].child,'AIxgPlayerVideo')
            }


          }
        } else {
          this.$message.error(res.message)
        }
      })
    //安防视频
    api
      .security({
        params: {
          limit: 166,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.length) {

            for (const iterator of res.data) {
              if (iterator.child == null) {
                iterator.child = []
              }
            }
            this.jiankong = res.data

            if (this.jiankong.length) {
              this.getcameraView(this.jiankong[0].child)
             
              
            }
      





          }
        } else {
          this.$message.error(res.message)
        }
      })

    //安全区域
    api
      .area({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            for (const iterator of res.data.list) {
              this.centerTopData[iterator.areaType - 1].pie += iterator.risk

              this.centerTopData[iterator.areaType - 1].textlist.push({
                name: iterator.areaName,
                value: iterator.risk,
                safeCase: iterator.safeCase,
                createTime: iterator.createTime,
              })
            }
            this.$nextTick(() => {
              let text = ''
              let color = ''
              for (const iterator of this.centerTopData) {
                let pieArr = []
                for (const item of iterator.textlist) {
                  pieArr.push(item.value)
                }
                iterator.pie = Math.max.apply(Math, pieArr)
                if (iterator.pie == 1) {
                  text = '低'
                  color = '#00ccff'
                } else if (iterator.pie == 2) {
                  text = '中'
                  color = '#24ffb1'
                } else {
                  text = '高'
                  color = '#f95458'
                }
                this.lipie(iterator.id, iterator.pie * 30, text, color)
              }
            })
          }
        } else {
          this.$message.error(res.message)
        }
      })
    //风险提示

    api
      .reminder({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.fxlist = res.data.list
            //数据
            this.$nextTick(() => {
              setTimeout(() => {
                let element = document.querySelectorAll('[riskdata-index]')
                for (const iterator of element) {
                  iterator.onclick = () => {
                    //绑定事件

                    // let index = iterator.getAttribute('riskdata-index')
                    // this.FXdialogclick(index)
                  }
                }
              }, 1000)
            })
          }
        } else {
          this.$message.error(res.message)
        }
      })

    //消防预案
    api
      .plan({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.length) {
            this.planId = res.data[0].id
            this.planList = res.data
            this.planValue = res.data[0]
          }
        } else {
          this.$message.error(res.message)
        }
      })
  },
  updated() {},
}
</script>

<style lang="less" scoped>
.smhome {
  .box {
    margin: 0.6rem;
  }

  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0 0.5rem 0.5rem;
  & > .left {
    height: 100%;
    overflow: hidden;
    width: 25%;
    & > .top{
      height: 60%;
      overflow: hidden;
    }
    & > .bottom {
      height: 40%;
      overflow: hidden;
    }
    

    
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  & > .center {
    height: 100%;
    overflow: hidden;
    width: 50%;
    & > .top{
      height: 60%;
      overflow: hidden;
    }
    & > .bottom {
      height: 40%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  & > .right {
    height: 100%;
    overflow: hidden;
    width: 25%;
    & > .top{
      height: 60%;
      overflow: hidden;      
    }
    & > .bottom {
      height: 40%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }

    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  .realtime {
    position: relative;
    .goBack{
      top: 0.5rem;
      left: 0.5rem;
      position: absolute;
      z-index: 99999;
    }
  }
  .fxlist {
    display: flex;
    flex-direction: column;
    // padding: 10px 15px;
    li {
      // flex: 1;
      padding: 0.5rem 15px;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      i {
        color: #f4af1b;
        position: relative;
        top: 1px;
        margin-right: 10px;
        font-size: 0.9rem;
      }
      span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      span:nth-child(2) {
        flex: 1;
      }
      span:nth-child(3) {
        width: 6rem;
        text-align: center;
      }
      span:nth-child(4) {
        width: 5rem;
        text-align: center;
      }
      span:nth-child(5) {
        width: 5rem;
        text-align: center;
      }
      span:nth-child(6) {
        flex: 1;
        margin-left: 1rem;
      }
      span:nth-child(7) {
        width: 8rem;
        text-align: right;
      }
    }
    li:nth-child(even) {
      background: #ffffff10;
    }
  }
  .xwlist {
    display: flex;
    flex-direction: column;
    li {
      // flex: 1;
      padding: 0.5rem 0.85rem;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      span:nth-child(1) {
        flex: 1;
      }
      span:nth-child(2) {
        width: 3.5rem;
        text-align: center;
      }
      span:nth-child(3) {
        width: 7rem;
        text-align: center;
      }
      span:nth-child(4) {
        width: 8rem;
        text-align: right;
      }
    }
    li:nth-child(even) {
      background: #ffffff10;
    }
  }
  .tab_title {
    position: absolute;
    top: 0;
    right: 12px;
    li {
      display: inline-block;
      line-height: 1.4rem;
      margin: 0px 5px;
      cursor: pointer;
      border-radius: 10px 10px 0 0;
      padding: 0px 15px;
      color: #ccd0f2;
      font-weight: normal;
      font-size: 0.7rem;
    }
    li.active {
      color: #fff;
      background: #3570ff;
    }
  }
  .ailist {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0.4rem;
    & > div {
      width: 50%;
      padding: 0.3rem;
      height: 50%;
      overflow: hidden;
      .img {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background: #0000044a;
        position: relative;
        .title {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 1.6rem;
          line-height: 1.6rem;
          color: #fff;
          font-size: 0.55rem;
          padding: 0 10px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          // background-color: rgba(0,0,0,.3);
          background-image: linear-gradient(
            rgba(0, 0, 0, 0.9),
            rgba(0, 0, 0, 0)
          );
        }
        img {
          width: 100%;
          height: 100%;
        }
        img.novideo {
          width: 7rem;
          height: 1.49rem;
        }
      }
    }
  }
  .center_top {
    display: flex;
    flex-direction: row;
    margin: 0.3rem 0;
    flex:1;
    .mybox1 {
      flex: 1;
      width: 20%;
      display: flex;
      flex-direction: column;
      margin: 0 0.3rem;
      overflow: hidden;
      font-size: 0.68rem;
      border-radius: 0.5rem;
      background-color: #010d2e89;
      border-top: 1px solid #2ca7e03f;
      .title1 {
        text-align: center;
        color: #24ffb1;
        border-radius: 0.5rem 0.5rem 0 0;
        height: 1.6rem;
        line-height: 1.5rem;
        background-color: #010d2e89;
      }
      .echarts {
        height: 5rem;
        flex-shrink: 0;
      }
      .table {
        flex: 1;
        cursor: pointer;
        padding: 0 0.2rem;
        overflow: hidden;
        li {
          // flex: 1;
          font-size: 0.56rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          margin: 0.3rem;
          padding: 0.2rem 0.4rem;
          border: #77819b dashed 1px;
          border-radius: 60px;
          span:nth-child(1) {
            flex: 1;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          span:nth-child(2) {
            width: 2.5rem;
            flex-shrink: 0;
            overflow: hidden;
            text-align: right;
          }
        }
        li:nth-child(n+4){
          display: none;
        }
  
        li::before {
          content: '1';
          display: inline-block;
          width: 0.8rem;
          text-align: center;
          line-height: 0.8rem;
          border-radius: 50%;
          height: 0.8rem;
          background: #00ccff;
          color: #071897;
          position: relative;
          left: -4px;
          margin-right: 4px;
        }
        li:nth-child(2)::before {
          content: '2';
        }
        li:nth-child(3)::before {
          content: '3';
        }
        li:nth-child(4)::before {
          content: '4';
        }
        li:nth-child(5)::before {
          content: '5';
        }
        li:nth-child(6)::before {
          content: '6';
        }
        li:nth-child(7)::before {
          content: '7';
        }
        li:nth-child(8)::before {
          content: '8';
        }
        li:nth-child(9)::before {
          content: '9';
        }
        li:nth-child(10)::before {
          content: '10';
        }
      }
    }
  }
  .FXdialog {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    & > .left {
      width: 50%;
      margin-right: 20px;
      .message {
        background: rgba(24, 255, 106, 0.1);
        border: #24ffb1 dashed 1px;
        padding: 0 0.5rem;
        align-items: center;
        border-radius: 10px;
        height: 3rem; margin-bottom: .3rem;
        display: flex;
        flex-direction: row;
        .text:nth-child(1) {
          flex: 1;
          display: flex;
          flex-direction: column;
          b {
            font-size: 0.8rem;
            color: #fff;
          }
        }
        .error,
        .time {
          font-size: 0.8rem;
          font-weight: 500;
          color: #24ffb1;
          margin-right: 2rem;
        }
        .state {
          width: 2.6rem;
          height: 2.6rem;
          color: #071897;
          text-align: center;
          line-height: 2.6rem;
          font-weight: bold;
          background: url(../../assets/images/state1.png) no-repeat;
          background-size: 100%;
        }
        .state.ing {
          background-image: url(../../assets/images/state2.png);
          color: #fff;
        }
      }
      .map {
        border: #3570ff solid 1px;
        height: 10rem;
        margin: 20px 0;
      }
      .video {
        border: #3570ff solid 1px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #071897;
        position: relative;
        width: 16rem;
        height: 10rem;
        overflow: hidden;
        .title1 {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 1.6rem;
          line-height: 1.6rem;
          color: #fff;
          font-size: 0.55rem;
          padding: 0 10px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          // background-color: rgba(0,0,0,.3);
          background-image: linear-gradient(
            rgba(0, 0, 0, 0.9),
            rgba(0, 0, 0, 0)
          );
        }
        video {
          width: 100%;
          height: 100%;
        }
        img.novideo {
          width: 50%;
        }
      }
    }
    & > .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      .box {
        border: #3570ff solid 1px;
        height: 92%;
        padding: 1rem;
      }
      .select {
        width: 16rem;
      }
      .el-row:last-child {
        flex: 1;
        .el-col {
          height: 100%;
        }
      }
    }
    .title {
      background: #3570ff;
      color: #fff;
      font-size: 0.75rem;
      padding: 0 6px 2px;
      display: inline-block;
      margin-bottom: 20px;
    }
    .el-row {
      margin-bottom: 30px;
    }
    .myform {
      display: flex;
      flex-direction: row;
      width: 100%;
      flex-wrap: wrap;
      .col1,
      .col2 {
        width: 50%;
        display: flex;
        flex-direction: row;
        padding: 8px 10px; font-size: .7rem;
        label {
          width: 5rem;
          text-align: right;
          margin-right: 10px;
          flex-shrink: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #fff;
        }
      }
      .col1 {
        width: 100%;
        span {
          overflow: hidden;
          text-overflow: clip;
          white-space: normal;
        }
      }
    }
  }
}
</style>


<style lang="less">


</style>
